import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { MaterialSoshSignatureDirective } from '../../directives/material-sosh-signature.directive';
import { MaterialFeedbackIconClass, MaterialFeedbackInfoLevel } from './material-feedback.data';

@Component({
    selector: 'ecm-mat-feedback',
    templateUrl: 'material-feedback.html',
    styleUrls: ['material-feedback.css'],
    standalone: true,
    imports: [NgClass, MaterialSoshSignatureDirective, NgTemplateOutlet],
})
export class MaterialFeedbackComponent implements OnInit, OnChanges {
    /**
     * Icon class
     * have both configuration for one-i and legacy style
     * @type {icon: string, iconColor: string, background: string}
     */
    public iconClass: { icon: string; iconColor: string; background: string };

    /**
     * Information level
     * Used by User-Replay parser
     * values interval : 0 (critical) to 4 (success)
     * @type {number}
     */
    public infoLevel: number;

    /**
     * Id may be provide to filter event emitter return in parent component
     * @type {string} id
     */
    @Input() public id?: string;

    /**
     * Feedback style
     * @type {string} style critical|alert|warning|info|success
     */
    @Input() public style: 'critical' | 'alert' | 'warning' | 'info' | 'success';

    /**
     * Feedback title
     * @type {string} title
     */
    @Input() public title?: string;

    /**
     * Feedback Text
     * @type {string|string[]}  text
     */
    @Input() public text?: string | string[];
    public displayedText: string[];

    /**
     * Is mobile
     * @param {boolean} isMobile
     * @deprecated Mobile render is now automatically set
     */
    @Input() public isMobile?: boolean;

    /**
     * Feedback confirmation style
     * @deprecated Style render is now automatically set
     * @type {string} confirmationStyle link|button-primary|button-secondary
     */
    @Input() public confirmationStyle?: 'link' | 'button-primary' | 'button-secondary';

    /**
     * Feedback confirmation label
     * @type {string} confirmationLabel
     */
    @Input() public confirmationLabel?: string;

    /**
     * Feedback data-e2e tag
     * 3 tags will be added to the DOM
     * {e2e}-{style} for the entire div
     * {e2e}-{style}-title for the title
     * {e2e}-{style}-confirmation for the confirmation
     * @type {string} e2e
     */
    @Input() public e2e?: string;

    /**
     * Forces one I display
     * @deprecated one-i is the only mode now, so no need to provide this parameter
     * @type {boolean}
     */
    @Input() public forceOneI?: boolean = false;

    /**
     * Force Polaris display
     * @deprecated polaris mode is gone, so no need to provide this parameter
     * @type {boolean}
     */
    @Input() public forcePolaris?: boolean = false;

    /**
     * Event emitter
     * @type {EventEmitter<string>}
     */
    @Output() public materialFeedbackConfirm: EventEmitter<string> = new EventEmitter<string>();

    public ngOnInit(): void {
        // sets iconClass based on style input
        this.iconClass = MaterialFeedbackIconClass[this.style];
        // sets info-level based on style input
        this.infoLevel = MaterialFeedbackInfoLevel[this.style];
        // sets e2e class based on style input
        this.e2e = (this.e2e || 'e2e-material-feedback') + '-' + this.style;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.text) {
            if (typeof this.text === 'string') {
                this.text = [this.text];
            }
            this.displayedText = this.text;
        }
    }

    /**
     * Emit event on feedback validation
     */
    public feedbackConfirm(): void {
        this.materialFeedbackConfirm.emit(this.id);
    }
}
